module.exports = __webpack_public_path__ + "media/music/drumkit_0-e35a43a4.mp3";